import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ModalUI } from '../UI/Modal/Modal';
import { ConfirmModalStyle } from './style';
import ButtonUI from '../UI/Button/Button';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  closeAction: () => void;
  confirmAction: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ open, closeAction, title, message, confirmAction }) => {
  const { t } = useTranslation();
  const { confirmModal, container, header, titleText, content, messageText, actions } = ConfirmModalStyle;

  const handleModalClose = (_event: {}, _reason: 'backdropClick' | 'escapeKeyDown') => {
    closeAction();
  };

  return (
    <ModalUI className={'confirm-modal'} open={open} onCloseHandler={handleModalClose} modalSx={confirmModal}>
      <Box sx={container}>
        <Box sx={header}>
          <Typography sx={titleText}>{title}</Typography>
        </Box>
        <Box sx={content}>
          <Typography sx={messageText}>{message}</Typography>
        </Box>
        <Box sx={actions}>
          <ButtonUI
            onClickHandler={() => closeAction()}
            text={t('cancel').toString()}
            variant="outlined"
            type="modalSecondary"
            dataTestId="pwid-confirm-modal-cancel"
          />
          <ButtonUI
            onClickHandler={() => confirmAction()}
            text={t('confirm').toString()}
            variant="contained"
            type="modalPrimary"
            dataTestId="pwid-confirm-modal-confirm"
          />
        </Box>
      </Box>
    </ModalUI>
  );
};

export default ConfirmModal;
